<div
  class="my-20 bg-white rounded-xl lg:flex justify-between xl:py-0">
  <div class="w-full max-w-full lg:max-w-xl xl:max-w-3xl col-span-1 p-8 md:p-16 xl:p-24">

    <h2
      class="font-bold mb-4 text-4xl leading-tight text-bleuCaliceo-300 uppercase">{{ 'pressAgency' | translate }}</h2>
    <p class="py-3"> {{ 'pressAgencySubTitle' | translate }} </p>
  </div>
  <form [formGroup]="form" class="w-full max-w-full lg:max-w-4xl col-span-1 p-8 md:p-16 xl:p-24">
    <div class="flex md:flex-row flex-col gap-4 mb-4">
      <div class="w-full md:w-1/2 mb-6 md:mb-0">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="grid-first-name">
          {{ 'yourFirstName' | translate }} <span class="text-red-600">*</span>
        </label>

        <input
          formControlName="firstName"
          class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="grid-first-name" type="text">
      </div>
      <div class="w-full md:w-1/2">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="grid-last-name">
          {{ 'yourLastName' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          formControlName="lastName"
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-last-name" type="text">
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-entity">
          {{ 'pressEntity' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          formControlName="entity"
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="your-entity" type="text">
      </div>
    </div>

    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-email">
          {{ 'yourEmail' | translate }} <span class="text-red-600">*</span>
        </label>
        <input
          formControlName="email"
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="your-email" type="email">
      </div>
    </div>
    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <app-tel-input [isRequired]="false" formControlName="phone"/>
      </div>
    </div>

    <div class="flex flex-wrap mb-4">
      <div class="w-full">
        <label class="text-gray-500 text-md font-semibold pb-2 block" for="your-subject">
          {{ 'subject' | translate }} <span class="text-red-600">*</span>
        </label>
        <textarea
          rows="4"
          formControlName="subject"
          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-5 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="your-subject"></textarea>
      </div>
    </div>
    <div class="flex items-center">
      <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
      <button type="button" [ngClass]="acceptTerms ? 'bg-bleuCaliceo-300' : 'bg-gray-200'"
              (click)="acceptTerms = !acceptTerms"
              class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
              role="switch" aria-checked="false" aria-labelledby="annual-billing-label">
            <span aria-hidden="true"
                  [ngClass]="acceptTerms ? 'translate-x-5' : 'translate-x-0'"
                  class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
      </button>
      <span class="ml-3 text-sm" id="annual-billing-label">
           <span class="font-medium text-gray-500">{{ 'acceptTerms' | translate }}</span> <span class="text-red-600">*</span>
          </span>
    </div>
    <p class="mt-10 text-rougeCaliceo-300">* {{ 'requiredInformation' | translate }}</p>
    <button type="button"
            appHoverGradient
            [appProgressClick]="submit"
            class="big-btn"
            [disabled]="form.invalid">
      {{ 'send' | translate }}
    </button>

  </form>
</div>
